/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Topwishlisted1Inputs */

const id_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling diinginkan`)
};

const ms_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling diingini`)
};

const da_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest ønskede`)
};

const de_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistgewünscht`)
};

const en_us2_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Wishlisted`)
};

const es_es2_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más deseados`)
};

const es_mx2_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más deseados`)
};

const fil_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakawishlist`)
};

const fr_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les plus souhaités`)
};

const it_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più desiderati`)
};

const hu_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legtöbbet kívántak`)
};

const nl_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest gewenst`)
};

const no_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest ønsket`)
};

const pl_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najczęściej dodawane do życzeń`)
};

const pt_br2_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais desejados`)
};

const pt_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais desejados`)
};

const ro_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai dorite`)
};

const fi_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toivotuimmat`)
};

const sv_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest önskade`)
};

const vi_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưa thích nhất`)
};

const tr_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok İstenenler`)
};

const cs_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejvíce přidané do seznamu přání`)
};

const bg_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-желани`)
};

const ru_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самое желаемое`)
};

const uk_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найбажаніші`)
};

const ar_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر رغبة`)
};

const hi_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप विशलिस्टेड`)
};

const th_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถูกใจมากที่สุด`)
};

const ja_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウィッシュリスト上位`)
};

const zh_cn2_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`心愿单榜`)
};

const zh_hant1_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`願望清單榜`)
};

const ko_nav_topwishlisted1 = /** @type {(inputs: Nav_Topwishlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위시리스트 TOP`)
};

/**
* | output |
* | --- |
* | "Top Wishlisted" |
*
* @param {Nav_Topwishlisted1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_topwishlisted1 = /** @type {((inputs?: Nav_Topwishlisted1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Topwishlisted1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_topwishlisted1(inputs)
	if (locale === "ms") return ms_nav_topwishlisted1(inputs)
	if (locale === "da") return da_nav_topwishlisted1(inputs)
	if (locale === "de") return de_nav_topwishlisted1(inputs)
	if (locale === "en-US") return en_us2_nav_topwishlisted1(inputs)
	if (locale === "es-ES") return es_es2_nav_topwishlisted1(inputs)
	if (locale === "es-MX") return es_mx2_nav_topwishlisted1(inputs)
	if (locale === "fil") return fil_nav_topwishlisted1(inputs)
	if (locale === "fr") return fr_nav_topwishlisted1(inputs)
	if (locale === "it") return it_nav_topwishlisted1(inputs)
	if (locale === "hu") return hu_nav_topwishlisted1(inputs)
	if (locale === "nl") return nl_nav_topwishlisted1(inputs)
	if (locale === "no") return no_nav_topwishlisted1(inputs)
	if (locale === "pl") return pl_nav_topwishlisted1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_topwishlisted1(inputs)
	if (locale === "pt") return pt_nav_topwishlisted1(inputs)
	if (locale === "ro") return ro_nav_topwishlisted1(inputs)
	if (locale === "fi") return fi_nav_topwishlisted1(inputs)
	if (locale === "sv") return sv_nav_topwishlisted1(inputs)
	if (locale === "vi") return vi_nav_topwishlisted1(inputs)
	if (locale === "tr") return tr_nav_topwishlisted1(inputs)
	if (locale === "cs") return cs_nav_topwishlisted1(inputs)
	if (locale === "bg") return bg_nav_topwishlisted1(inputs)
	if (locale === "ru") return ru_nav_topwishlisted1(inputs)
	if (locale === "uk") return uk_nav_topwishlisted1(inputs)
	if (locale === "ar") return ar_nav_topwishlisted1(inputs)
	if (locale === "hi") return hi_nav_topwishlisted1(inputs)
	if (locale === "th") return th_nav_topwishlisted1(inputs)
	if (locale === "ja") return ja_nav_topwishlisted1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_topwishlisted1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_topwishlisted1(inputs)
	return ko_nav_topwishlisted1(inputs)
});
export { nav_topwishlisted1 as "nav.topWishlisted" }